/** Normaliza respuestas de listados de sucursales (empresa, usuarios, etc.). */

/** Interpreta `Sucursal.Activo` del API (bit/boolean); sin valor → false (no asumir activa). */
export const parseSucursalActivo = (value) => {
  if (value === true || value === 1 || value === '1') return true;
  const s = String(value ?? '').trim().toLowerCase();
  if (s === 'true' || s === 'si' || s === 'yes') return true;
  return false;
};

export const unwrapJsonRoot = (body) => {
  if (body == null || typeof body !== 'object') return body;
  if (Array.isArray(body)) return body;
  if (Array.isArray(body.data)) return body.data;
  if ((body.success === true || body.success === 1) && body.data != null) return body.data;
  return body;
};

export const asSucursalesArray = (raw) => {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'object') {
    if (Array.isArray(raw.data)) return raw.data;
    if (Array.isArray(raw.sucursales)) return raw.sucursales;
    if (Array.isArray(raw.items)) return raw.items;
  }
  return [];
};

export const normalizeSucursalesList = (raw) => {
  const root = raw != null && typeof raw === 'object' && !Array.isArray(raw) ? unwrapJsonRoot(raw) : raw;
  const arr = asSucursalesArray(root);
  const out = [];
  for (const row of arr) {
    if (!row || typeof row !== 'object') continue;
    const sucursalId = row.SucursalID ?? row.sucursalId ?? row.id ?? row.Id;
    const nombreSucursal = String(
      row.NombreSucursal ?? row.nombreSucursal ?? row.nombre ?? row.Nombre ?? '',
    ).trim();
    if (sucursalId == null || String(sucursalId).trim() === '') continue;
    out.push({
      sucursalId,
      nombreSucursal: nombreSucursal || '—',
      activo: parseSucursalActivo(row.Activo ?? row.activo),
    });
  }
  return out;
};
